import { createContext } from 'react';
import type {
  Usuario,
  DadosCadastro,
} from '../tipos/tiposAutenticacao';

export interface ValoresContextoAutenticacao {
  usuario: Usuario | null;
  token: string | null;
  estaAutenticado: boolean;
  estaCarregando: boolean;
  erro: string | null;
  login: (email: string, senha: string) => Promise<void>;
  cadastrar: (dados: DadosCadastro) => Promise<void>;
  logout: () => void;
}

export const ContextoAutenticacao = createContext<ValoresContextoAutenticacao | undefined>(undefined);